import React, { lazy, Suspense } from "react";
import Layout from "../layout/DefaultLayout";
import LazyLoader from "@/components/LazyLoader";
import useFilter from "@/hooks/useFilter";
import useObjects from "@/apis/objects";
import { useQuery } from "@tanstack/react-query";
const Preview = lazy(() => import("@/components/Preview/Preview"));

const Objects = React.memo(() => {
  const { filterOption } = useFilter({
    query: {
      sectionStatus: "publish",
    },
  });
  const { getFeed } = useObjects();
  const feed = useQuery({
    queryKey: ["object-feed", filterOption],
    queryFn: () => getFeed(filterOption),
  });

  return (
    <Layout viewMobTopNav>
      <Suspense fallback={<LazyLoader />}>
        <Preview
          data={feed.data?.data}
          type="objects"
          parentclass="mb-10"
          isLoading={feed.isLoading}
        />
      </Suspense>
    </Layout>
  );
});

export default Objects;
